import React from "react";
import AddButtonNew from '../AddButton/AddButtonNew';
import DateHelper from "../DateHelper/DateHelper";
import DatePickerInput from "../DatePickerInput/DatePickerInput";
import TimePickerInput from '../TimePickerInput/TimePickerInput';
// import TimePicker from "../TimePicker/TimePicker"

export default class EmailCampaignBuilderEmails extends React.Component{
  constructor(props) {
    super(props);
    this.renderEmailSelectBoxes = this.renderEmailSelectBoxes.bind(this)
  };

  render() {
    return (
      <div>
        {/* {this.renderAddButton()} */}
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6">
                  <h3 className="panel-title">
                    {I18n.t('email_details')}
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <AddButtonNew
                    key={this.props.email_campaign_id || this.generateId()}
                    model="Email"
                    text={I18n.t('add')}
                    new_button={false}
                    ids={Object.keys(this.props.emailFields).length > 0 ? Object.keys(this.props.emailFields).map((email) => { return email; }) : null}
                    onAdd={this.props.onAddEmailField}
                    buttonClasses="btn btn-secondary"
                    generalPosition="left"
                  />
                </div>
                <div className="clearfix"></div>
              </div>
              {this.renderEmailSelectBoxes()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderEmailSelectBoxes() {
    var emailSelectBoxes = this.props.emailSelectBoxes.map((select, idx) => {
      return (
        <div key={idx} className="col-md-12">
          <div className="pull-right" style={{ marginTop: '25px' }}><button type="button" className="btn btn-dark btn-sm" style={{ paddingLeft: '7px', paddingRight: '7px' }} onClick={e => this.props.removeEmailField(select.value, idx)}>{I18n.t('remove')}</button></div>
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('email_templates')}`}</label>
            <div className="form-group">
              <p>{select.value}</p>
            </div>
          </div>
          {this.renderEmailTrigger(select.value, select.id)}
        </div>
      )
    });

    return emailSelectBoxes
  }

  renderEmailTriggerOptions(trigger, value, id) {
    if(trigger == I18n.t("specific_date")) {
      return (
        <div>
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{`${I18n.t('select_date')}*`}</label>
            <div className="form-group">
              <DatePickerInput
                selectedDate={this.props.emailFields[value] && this.props.emailFields[value].date ? new Date(this.props.emailFields[value].date) : ''}
                dateFormat={this.props.date_format}
                customChangeHandler={this.props.onChangeEmailDateTime} 
                customChangeSource='EmailCampaigns'
                field={`${value}_date`}
              />
                {this.fieldErrors(id + "date")}
            </div>
          </div>
          <div className="col-md-2">
            <label style={{ marginTop: '15px' }}>{I18n.t('select_time')}</label>
            <TimePickerInput
              format={this.props.time_format}
              selectedTime={this.props.emailFields[value] && this.props.emailFields[value].time ? DateHelper.parse(this.props.emailFields[value].time) : ''} 
              customChangeHandler={this.props.onChangeEmailDateTime}
              customChangeSource='EmailCampaigns'
              field={`${value}_time`} 
            />
          </div>
        </div>
      )
    }
  }

  renderEmailTrigger(value, id) {
    var options = []
    var emailFields = this.props.emailFields

    this.props.emailTriggers.map((trigger, idx) => {
      options.push(<option key={idx} name={trigger}>{I18n.t(trigger)}</option>)
    })

    options.unshift(<option key="disabled" disabled="disabled">{I18n.t('select_ellipsis')}</option>)
    return (
      <div>
        <div className="col-md-2">
          <label style={{ marginTop: '15px' }}>{`${I18n.t('column')} ${I18n.t('trigger')}*`}</label>
          <div className="form-group">
            <select className="form-control" onChange={(e) => this.props.onChangeEmailTriggerSelect(e, value)} value={emailFields[value] && emailFields[value].trigger ? emailFields[value].trigger : I18n.t('select_ellipsis')}>{options}</select>
            {this.fieldErrors(id + "trigger")}
          </div>
        </div>
        {this.renderEmailTriggerOptions(emailFields[value] && emailFields[value].trigger ? emailFields[value].trigger : null, value, id)}
      </div>
    )
  }

  fieldErrors(field) {
    if (this.props.errors[field]) {
      return (
        <div className="help-block">
          <ul>{this.props.errors[field]}</ul>
        </div>
      )
    } else {
      return false
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return '-' + text;
  }

};
